import React from 'react'
import { routes } from './utils/routes'
import AdminDashboard from './pages/feature/admin-dashboard/admin-dashboard'
import LayoutSettings from './contexts/settings/layouts.context'
import Settings from './pages/feature/settings/settings'

import TitleTypeComponent from './contexts/settings/titlettype.context'
import TruckList from './pages/feature/truck/truckList'
import DriversList from './pages/feature/drivers/driversList'
import DriverProfile from './pages/feature/drivers/driverProfile'
import CheckList from './pages/feature/checklist/checkList'
import TruckCheckList from './pages/feature/checklist/truckCheckList'
import CreateCheckList from './pages/feature/checklist/createCheckList'
import ForgotPassword from './pages/authentication/forgot-password/forgotPassword'
import CheckListDetailView from './pages/feature/checklist/checkListDetailView'
import ResetPassword from './pages/authentication/reset-password/resetPassword'
//import Otp from './pages/authentication/otp/otp'
import FleetList from './pages/feature/drivers/fleetList'


export const authRoutes = [
  {
    id: 1,
    path: routes.adminDashboard.path,
    element: <AdminDashboard />,
  },
  {
    id: 2,
    path: routes.settingsLayout.path,
    element: <LayoutSettings />,
  },
  {
    id: 4,
    path: routes.titleTypesettings.path,
    element: <TitleTypeComponent />,
  },
  {
    id: 8,
    path: routes.settings.path,
    element: <Settings />,
  },
  {
    id: 10,
    path: routes.truckList.path,
    element: <TruckList />,
  },
  {
    id: 11,
    path: routes.driversList.path,
    element: <DriversList />,
  },
  {
    id: 12,
    path: routes.driverProfile.path,
    element: <DriverProfile />,
  },
  {
    id: 13,
    path: routes.checkList.path,
    element: <CheckList />,
  },
  {
    id: 14,
    path: routes.truckCheckList.path,
    element: <TruckCheckList />,
  },
  {
    id: 15,
    path: routes.fleetList.path,
    element: <FleetList />,
  },
  {
    id: 16,
    path: routes.createCheckList.path,
    element: <CreateCheckList />,
  },
  {
    id: 17,
    path: routes.checkListDetailView.path,
    element: <CheckListDetailView />,
  },
  {
    id: 18,
    path: routes.forgotPassword.path,
    element: <ForgotPassword />,
  },
  {
    id: 19,
    path: routes.restPassword.path,
    element: <ResetPassword />,
  },
 // {
  //  id: 20,
   // path: routes.otp.path,
    //element: <Otp />,
//  }
]
